// extracted by mini-css-extract-plugin
export var container = "_6e-0";
export var error = "_6e-9";
export var label = "_6e-5";
export var light = "_6e-6";
export var md = "_6e-3";
export var sm = "_6e-2";
export var thin = "_6e-8";
export var thinBold = "_6e-7";
export var vertical = "_6e-4";
export var xs = "_6e-1";